{
  "help": "Spikker",
  "info": "Teave"
}
